function isItemOwned (inventory, item, variationUuid = null) {
  if (! inventory) {
    return false;
  }

  const ownedItem = inventory?.find(i => i.uuid === item.uuid);
  
  if (item.type === 'item-bundle') {
    return (!! ownedItem) || areAllBundleSubItemsOwned(inventory, item);
  }

  if (! ownedItem) {
    return false;
  }
  
  if (item.type === 'avatar-3d-part') {
    if (variationUuid) {
      // If variationUuid is set, check if the given variation is owned.
      return !! inventory.find(i => i.type === 'avatar-3d-part' && i.uuid ===  item.uuid && i.variation?.color?.uuid === variationUuid);
    }

    // If variationUuid is not set, check if all variations are owned.
    return areAllPartColorsOwned(inventory, item);
  }
  
  return true;
}

function areAllBundleSubItemsOwned (inventory, item) {
  const bundleItems = item.items;

  if (bundleItems.length === 0) {
    // If the bundle has no sub items, it's not owned (free coins bundle etc).
    return false;
  }

  const ownedItems = bundleItems.filter(bundleItem => inventory.find(inventoryItem => inventoryItem.uuid === bundleItem.uuid));
  // If all items in the bundle are unlocked, the bundle is owned.
  if (ownedItems.length === bundleItems.length) {
    return true;
  }

  return false;
}

function areAllPartColorsOwned (inventory, item) {
  if (! inventory) {
    return false;
  }

  if (item.type !== 'avatar-3d-part') {
    return false;
  }

  if (item.colors?.length === 0) {
    // If the item has no colors, it is owned.
    return true;
  }

  // Check if all colors are owned.
  for (const color of item.colors) {
    const ownedItem = inventory?.find(i => i.uuid === item.uuid && i.variation?.color?.uuid === color.uuid);

    if (! ownedItem) {
      // At least one color is not owned.
      return false;
    }
  }

  // All colors are owned.
  return true;
}

function getBestPrice (item) {
  let bestPrice = null;
  const currentTime = new Date();

  for (const price of (item.prices || [])) {
    const startsAt = price.startsAt ? new Date(price.startsAt) : null;
    const endsAt = price.endsAt ? new Date(price.endsAt) : null;

    // Check if the price is currently valid
    if ((startsAt === null || startsAt <= currentTime) && (endsAt === null || endsAt >= currentTime)) {
      if (bestPrice === null || price.amount < bestPrice.amount) {
        bestPrice = price;
      }
    }
  }

  return bestPrice;
}
export {
  isItemOwned,
  getBestPrice
}